type EventItem = {
  checks?: unknown[];
  parent_name: string;
};

export function groupEventsWithCount(events: EventItem[]): Map<string, number> {
  const countMap = new Map<string, number>();
  events.forEach((event) => {
    const parentName = event.parent_name;
    const checkCount = event.checks?.length ?? 1;
    if (countMap.has(parentName)) {
      countMap.set(parentName, (countMap.get(parentName) ?? 0) + checkCount);
    } else {
      countMap.set(parentName, checkCount);
    }
  });
  return countMap;
}
